import { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import AccordionServicos from './accordionServicos'
import CardServicos from './cardServicos'
import OtimizeSeuNegocio from './OtimizeSeuNegocio'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import Container from './container'

export function Impacto() {
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null)
  
  // Handle accordion toggle in mobile view - exactly like in etapas.jsx
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
    }
  }
  const servicosData = [
    {
      id: 1,
      icon: '../assets/icones/finep/icone-servico1.png',
      iconHover: '../assets/gestao-icone.png',
      title: 'Acesso a financiamento',
      text: 'As empresas têm acesso a recursos financeiros expressivos para impulsionar projetos inovadores, reduzindo riscos e potencializando investimentos.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 2,
      icon: '../assets/icones/finep/icone-servico2.png',
      iconHover: '../assets/icone-suporte.png',
      title: 'Aceleração da inovação',
      text: 'Gerenciamos os projetos de inovação para que sejam desenvolvidos de forma ágil e eficiente, gerando produtos e serviços com vantagens competitivas significativas.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 3,
      icon: '../assets/icones/finep/icone-servico3.png',
      iconHover: '../assets/icone-risco.png',
      title: 'Melhoria na gestão da  inovação',
      text: 'Com nossa expertise e suporte contínuo, as empresas evoluem na gestão da inovação, garantindo que suas iniciativas estejam alinhadas aos objetivos estratégicos e operacionais.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 4,
      icon: '../assets/icones/finep/icone-servico4.png',
      iconHover: '../assets/gestao-icone.png',
      title: 'Maximização de resultados',
      text: 'Elevamos as chances de aprovação das propostas submetidas à FINEP, por conta da nossa expertise estratégica, maximizando o retorno sobre o investimento em inovação.',
      glowColor: '#FC00218C',
      url: '',
    },
  ]

  return (
    <div className="w-full bg-[rgb(15,7,57)] py-20 relative overflow-hidden text-white">
      <Container className="z-10">
        <h2 className="font-inter-light text-[32px] md:text-5xl lg:text-[60px] text-center mb-12">
          Impacto dos <br className="md:hidden" />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9]">
            nossos serviços
          </span>
        </h2>
        <div className="relative mx-[-1rem] md:mx-[-2rem] hidden md:block">
          <Carousel className="overflow-visible">
            <div className="flex justify-end absolute right-8 md:right-16 top-6 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
            <CarouselContent className="py-8 px-6 md:px-8">
              {servicosData.map((servico, index) => (
                <CarouselItem
                  key={index}
                  className="basis-full sm:basis-1/2 md:basis-1/2 lg:basis-1/3 pl-4 md:pl-6"
                >
                  <div className="relative overflow-visible px-2">
                    <div 
                      className="relative h-[380px] mb-8" 
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <CardServicos {...servico} height={380} className="hidden md:block" />
                      
                      {/* OtimizeSeuNegocio component that appears on hover */}
                      <div 
                        className={`hidden md:block absolute left-0 right-0 bottom-[-90px] transition-all duration-300 ${hoveredIndex === index ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                      >
                        <OtimizeSeuNegocio 
                          text="Otimize seu negócio!"
                          buttonText="Contratar"
                          useFormularioRD={true}
                          type="gradient"
                          className="w-full"
                        />
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          {/* Removed the fixed OtimizeSeuNegocio component since it now appears on hover */}
        </div>
        <div className="md:hidden space-y-4">
          {servicosData.map((servico, index) => (
            <div key={index} className="relative">
              <AccordionServicos
                key={`mobile-${index}`}
                {...servico}
                doesThereButton={false}
                className="bg-[rgb(32,27,63)] backdrop-blur-[40px] text-left"
                onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                accordionIndex={index}
              />
              
              {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
              <div 
                className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                  ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                style={{
                  transitionProperty: 'max-height, opacity, transform',
                  transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                  zIndex: 20,
                  position: 'relative'
                }}
              >
                <OtimizeSeuNegocio 
                  text="Otimize seu negócio!"
                  buttonText="Contratar"
                  useFormularioRD={true}
                  type="gradient"
                  className="w-full mt-4"
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
